import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link, withRouter } from "react-router-dom"
import Swal from 'sweetalert2'
import {
  Button, Card, Col, Container, Input, Label, Row, TabContent, TabPane,
  Nav,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  NavItem,
  NavLink,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormGroup,
  Alert
} from "reactstrap"
import classnames from "classnames"

import { map } from "lodash"
import axios from "axios"
import { API_URL } from "helpers/app_url"
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Breadcrumbs from "../../components/Common/Breadcrumb"
import EmailToolbar from "./email-toolbar"
import { Formik, Form, Field, ErrorMessage } from 'formik';
import UpdateButton from "components/buttons/updateBtn";
import * as Yup from 'yup';
import moment from "moment";
import EmailSideBar from "./email-sidebar"
import { toast, ToastContainer } from "react-toastify";
import SafeHTML from "components/buttons/SafeHTML"
import ComposeMail from "components/dropdowns/ComposeEmail"
import SafeField from "helpers/SafeField";
class EmailInbox extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      activeTab: "1",
      resultArray: [],
      isLoading: false,
      agentData:'',
      currentPage: 1,
      totalPages: 1,
      totalEmails:0,
      selectedEmails: [],
      parserTypes: [],
      filter: null,
       showCompose: false,
    }
    this.togglemodal.bind(this)
    this.toggleTab = this.toggleTab.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
      this.toggleEmailMapper = this.toggleEmailMapper.bind(this)
     this.handleSubmitMapper = this.handleSubmitMapper.bind(this);
    this.handleTempDelete = this.handleTempDelete.bind(this);
  }
  setFilter = (filter) => {
    this.setState({ filter });
  };
    toggleEmailMapper() {
    this.setState({ isMapper: !this.state.isMapper });
  }
   loadData() {
      const obj = JSON.parse(localStorage.getItem("authUser"));
      const token = obj.resultData.bearerToken;
      const str = 'Bearer ' + token;
      axios.get(`${API_URL}CustomEmailTemplate/alltemplates`, {
        params: {
          agentId: localStorage.getItem("userId"),
        }, headers: { Authorization: str }
      })
        .then(res => {
          this.setState({ emailMapperList: res.data });
        });
    }
   
      loadParserType = (mappingTemplateId, setFieldValue) => {
         if (!mappingTemplateId) {
          this.setState({ parserTypes: [] });
          setFieldValue("parserTypeId", "");
          return;
    }
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj.resultData.bearerToken;
        const str = 'Bearer ' + token;
        axios.get(`${API_URL}EmailParserType/allagenttype`, {
          params: {
            typeId: parseInt(mappingTemplateId),
            agentId: localStorage.getItem("userId"),
          }, headers: { Authorization: str }
        })
          .then(res => {
            this.setState({ parserTypes: res.data });
          });
      }
      handleSubmitMapper = (values, actions) => {
        toast.loading("Please wait...");
        const payload = {
          id: 0,
          customEmailTemplateId: "b107ace4-ceb2-4d7d-acb6-28454c66c431",
          from: values.mappingFromEmail,
          to: values.mappingFromEmail,
          templateId: parseInt(values.mappingTemplate),
          parserTypeId: isNaN(parseInt(values.parserTypeId)) ? 0 : parseInt(values.parserTypeId),
          agentId: parseInt(localStorage.getItem("userId")),
          isActive: true
        }
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj.resultData.bearerToken;
        const str = 'Bearer ' + token;
        var authOptions = {
          method: 'post',
          url: `${API_URL}CustomEmailTemplate`,
          data: payload,
          headers: { Authorization: str }
        };
    
        axios(authOptions)
          .then((response) => {
            if (response.data.success) {
              toast.dismiss();
              toast.success("Saved successfully");
              actions.resetForm();
              this.loadData();
            }
            else {
              toast.dismiss();
              toast.success(response.data.validationErrors[0]);
              this.loadData();
            }
          })
          .catch((error) => {
            toast.dismiss();
            toast.success("Error" + error);
          })
      }
    
      handleTempDelete = (emailM) => {
        toast.loading("Please wait...");
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj.resultData.bearerToken;
        const str = 'Bearer ' + token;
        var authOptions = {
          method: 'delete',
          url: `${API_URL}CustomEmailTemplate/` + emailM.id,
          headers: { Authorization: str }
        };
    
        axios(authOptions)
          .then((response) => {
            if (response.data.success) {
              toast.dismiss();
              toast.success("Deleted successfully");
              this.loadData();
            }
            else {
              toast.dismiss();
              toast.success(response.data.validationErrors[0]);
              this.loadData();
            }
          })
          .catch((error) => {
            toast.dismiss();
            toast.success("Error" + error);
          })
      };
  handleCheckboxChange = (emailId) => {
    this.setState((prevState) => {
      const selectedEmails = [...prevState.selectedEmails];
      if (selectedEmails.includes(emailId)) {
        selectedEmails.splice(selectedEmails.indexOf(emailId), 1);
      } else {
        selectedEmails.push(emailId);
      }
      return { selectedEmails };
    });
  };
  componentDidMount() {
     this.loadData();
    //this.loadParserType();
    if (!this.state.agentData) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const userId = localStorage.getItem("userId");
    
    this.setState({ isLoading: true });
    axios.get(`${API_URL}Agent/${userId}`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
      const agentData = res.data;
      this.setState({ agentData }, () => {
        const agentId = this.state.agentData.agentId;
         this.fetchAllEmail(agentId);
        // axios.get(`${API_URL}Gmail/SyncGmails/${agentId}/0`, {
        //   headers: { Authorization: `Bearer ${token}` }
        // })
        // .then(response => {
        //   if (response.data === 'Success') {
       
        //     this.fetchInboxMails(agentId, this.state.currentPage);
        //   }
        // })
        // .catch(error => {
        //   console.error('Error syncing gmails:', error);
        //   this.setState({ isLoading: false });
        // });
      });
    })
    .catch(error => {
      console.error('Error fetching agent data:', error);
      this.setState({ isLoading: false });
    });
    }
  }
  fetchInboxMails(agentId, email, page) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    
    axios.get(`${API_URL}Gmail/GetMailFromByToEmailPagination/${agentId}/${email}/${page}/20/false/false`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(secondResponse => {
      
      
      this.setState({
        inboxMails: secondResponse.data.items, 
        totalPages: secondResponse.data.totalPages || 1, 
        isLoading: false,
        
      totalEmails:secondResponse.data.totalPages 
      });
    })
    .catch(error => {
      console.error('Error fetching data from second API:', error);
      this.setState({ isLoading: false });
    });
  }
  fetchInbox(agentId, page) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    
    axios.get(`${API_URL}Gmail/GetMailFromByAgentPagination/${agentId}/${page}/20/false/false`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(secondResponse => {
      
      
      this.setState({
        inboxMails: secondResponse.data.items, 
        totalPages: secondResponse.data.totalPages || 1, 
        isLoading: false,
        
      totalEmails:secondResponse.data.totalPages 
      });
    })
    .catch(error => {
      console.error('Error fetching data from second API:', error);
      this.setState({ isLoading: false });
    });
  }
  handleNextPage = () => {
    const { currentPage, totalPages, agentData , selectedEmail } = this.state;
    //
    if (currentPage < totalPages) {
      this.setState({ currentPage: currentPage + 1, isLoading: true }, () => {
        this.fetchInboxMails(agentData.agentId, 'esimplifiedit@gmail.com',  this.state.currentPage);
      });
    }
  };
  handlePreviousPage = () => {
    const { currentPage, agentData, selectedEmail  } = this.state;
   
    if (currentPage > 1) {
      this.setState({ currentPage: currentPage - 1, isLoading: true }, () => {
         if (selectedEmail === "") {
                       
      this.fetchInbox(agentData.agentId, this.state.currentPage);
    } else {
    
      this.fetchInboxMails(agentData.agentId, selectedEmail, this.state.currentPage);
    }
       
      });
    }
  };
handlePageChange = (page) => {
  const { agentData, selectedEmail } = this.state;
   //
  this.setState({ currentPage: page, isLoading: true }, () => {
     if (selectedEmail === "") {
                       
      this.fetchInbox(agentData.agentId, page);
    } else {
    
      this.fetchInboxMails(agentData.agentId, selectedEmail, page);
    }
    
  });
};

  toggleTab(tab) {

    if (this.props.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      })
    }
  }

  togglemodal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }))
  }
  
  handleSubmit(value) {
    this.setState({ isLoading: true });
    const obj = JSON.parse(localStorage.getItem("authUser"));
    const token = obj?.resultData?.bearerToken;
    const payload = {
      //name: value.name,
      //from:value.from,
      to: value.to,
      subject:value.subject,
      body:value.body,
      agentId:value.agentId
    }
    axios.post(`${API_URL}Gmail`, payload, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      
      this.setState({ isLoading: false });
      this.togglemodal();
    })
    .catch(error => {
      console.error("API Error:", error);
      this.setState({ isLoading: false });
    });
  }
  handleDelete = async () => {
    const { selectedEmails } = this.state;
  
    if (selectedEmails.length === 0) {
      Swal.fire({
        title: 'No emails selected',
        text: 'Please select emails to delete.',
        icon: 'warning',
        confirmButtonText: 'OK',
      });
      return;
    }
    
   
    //const confirmed = window.confirm("Are you sure you want to delete the selected emails?");
    const result = await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this action!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it',
    });
    if (result.isConfirmed) {
      try {
        const obj = JSON.parse(localStorage.getItem("authUser"));
        const token = obj?.resultData?.bearerToken;
        const headers = {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        };
        for (let emailId of selectedEmails) {
          const url = `${API_URL}Gmail/DeleteGoogleEmail/${this.state?.agentData?.agentId}/${emailId}/1`;
          await axios.get(url, { headers });
          this.setState((prevState) => {
            const updatedMails = prevState.inboxMails.filter(
              (inbox) => inbox.messageID !== emailId
            );
            return { inboxMails: updatedMails };
          });
        }
        this.setState({ selectedEmails: [] });
  
      } catch (error) {
        console.error("Error deleting emails", error);
        alert("An error occurred while deleting emails.");
      }
    }
  };
  getPaginationPages = (currentPage, totalPages) => {
  const pages = [];

  if (totalPages <= 6) {
    for (let i = 1; i <= totalPages; i++) {
      pages.push(i);
    }
  } else {
    if (currentPage <= 4) {
      pages.push(1, 2, 3, 4, 5, '...', totalPages);
    } else if (currentPage >= totalPages - 3) {
      pages.push(1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
    } else {
      pages.push(1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages);
    }
  }

  return pages;
};
// fetchAllEmail(agentId) {
//     const obj = JSON.parse(localStorage.getItem("authUser"));
//     const token = obj?.resultData?.bearerToken;
//     axios.get(`${API_URL}EmailAgentGeneralCredentials/allforagent?agentId=${agentId}`, {
//       headers: { Authorization: `Bearer ${token}` }
//     })
//     .then(response => {
//       const emailList = response.data;
//     this.setState({ emailList });
//     const defaultEmailObj = emailList.find(e => e.defaultUseToSendmail === true);

//     if (defaultEmailObj) {
//       this.fetchInboxMails(agentId, defaultEmailObj.agentEmailId, this.state.currentPage);
//     }
//     })
//     .catch(error => {
//       console.error('Error fetching data from second API:', error);
//       this.setState({ isLoading: false });
//     });
//   }

fetchAllEmail(agentId) {
  const obj = JSON.parse(localStorage.getItem("authUser"));
  const token = obj?.resultData?.bearerToken;

  axios
    .get(`${API_URL}EmailAgentGeneralCredentials/allforagent?agentId=${agentId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((response) => {
      const emailList = response.data;
      this.setState({ emailList });

    
      const defaultEmailObj = emailList.find((e) => e.defaultUseToSendmail === true);

      if (defaultEmailObj) {
        this.setState(
          { selectedEmail: defaultEmailObj.agentEmailId, currentPage: 1 },
          () => {
            this.fetchInboxMails(agentId, defaultEmailObj.agentEmailId, 1);
          }
        );
      }
    })
    .catch((error) => {
      console.error("Error fetching email list:", error);
      this.setState({ isLoading: false });
    });
}
 handleSend = (payload) => {
    
    alert("Mail sent successfully!");
    this.setState({ showCompose: false });
  };
  render() {
      const { emailMapperList, parserTypes, showCompose } = this.state;
      const { isResponsive } = this.props;
    //meta title
    document.title = "Email | Realty Space";

    const { inboxMails, isLoading, currentPage, totalPages} = this.state;
     const allLocal = localStorage.getItem('localData')
    const localization = JSON.parse(allLocal);
    const { selectedEmails } = this.state;
    const validationSchema = Yup.object().shape({
      to: Yup.string().email('Invalid email format').required('Email is required'),
      subject: Yup.string().required('Subject is required'),
      message: Yup.string().required('Message is required'),
    });
   const { filter } = this.state;
   //
    return (
      <React.Fragment>
         {/* {isLoading ? (
                    <div className="rs-loader-overlay">
                    <div className="rs-loader"></div>
                    </div>
                ) : null} */}
           <ToastContainer autoClose={2000}></ToastContainer>
        <div className="page-content">
          <Container fluid>
            {/* Render Breadcrumbs */}
             {/* <div className="w-100">
      <Alert
        color="danger"
       
        className="d-flex justify-content-between align-items-center"
        style={{
          borderRadius: "0",
          padding: "12px 18px",
          fontSize: "14px",
          color:'#000'
        }}
      >
        <span>
          <strong>richardaxel68@gmail.com</strong> is disconnected.  
          Reconnect to continue receiving emails for this account.
        </span>

        <Button color="light" size="sm" className="fw-bold">
          Reconnect
        </Button>
      </Alert>
    </div> */}
            <Row className="project-header">
            <Col xl="1">
            <Breadcrumbs title="Email" breadcrumbItem="Inbox" />
           </Col>
            <Col xl="2">
            <div className="pt-2 mt-2">
{/*                   
                 <select
                  className="form-control"
                  name="email"
                  id="email"
                  onChange={(e) => this.fetchInboxMails(this.state.agentData.agentId, e.target.value, this.state.currentPage)}
                >
                  {this.state.emailList && this.state.emailList.map((email, idx) => (
                    <option
                      key={idx}
                      value={email.agentEmailId}
                      selected={email.defaultUseToSendmail === true}
                    >
                      {email.agentEmailId}
                    </option>
                  ))}
                 </select> */}

                 <select
                  className="form-control"
                  name="email"
                  id="email"
                  value={this.state.selectedEmail || ""} 
                  onChange={(e) => {
                    const selectedEmail = e.target.value;
                    this.setState({ selectedEmail, currentPage: 1 }, () => {
                       if (selectedEmail === "") {
                       
                        this.fetchInbox(this.state.agentData.agentId, 1);
                      } else {
                      
                        this.fetchInboxMails(this.state.agentData.agentId, selectedEmail, 1);
                      }
                    });
                  }}
                >
                  <option value="">All Email</option>
                  {this.state.emailList &&
                    this.state.emailList.map((email, idx) => (
                      <option key={idx} value={email.agentEmailId}>
                        {email.agentEmailId}
                      </option>
                    ))}
                </select>

              
            </div>
          
           </Col>
           {/* <Col sm="1">
             <button className="btn btn-add same-size-btn" style={{marginTop:13}}><i className=" fas fa-recycle"></i> Sync</button>
           </Col>          */}
           <Col xl="8">
              {!isResponsive ? (
           <button 
                 className="btn btn-light same-size-btn float-end"
                 style={{marginTop:15}}
                 onClick={this.toggleEmailMapper}
               >
                 Email Mapper
               </button>
              ):(
                <div style={{marginBottom:20}}></div>
              )}
           </Col>
           </Row>
           
           
            <Row className="mt-20">
              <Col xs="12">
                {/* Render Email SideBar */}
                <Row>
                  <Col sm="6">
                   <EmailSideBar agentData={this.state?.agentData?.agentId} />
                  </Col>
                    <Col sm="6">
                     {!isResponsive &&(
                    <span className="float-end">
                      <span className="me-2" style={{marginTop:10, fontSize:16, fontWeight:700}}>Filter By : </span>
                     <button 
                      className="btn btn-light btn-buyer same-size-btn ms-auto" onClick={() => this.setFilter(1)}>
                      Buyer listings
                    </button>
                
                  <button 
                      className="btn btn-light btn-seller same-size-btn"
                      onClick={() => this.setFilter(2)}
                    >
                      Seller showings
                    </button>
                
                      <button 
                      className="btn btn-light btn-inquiry same-size-btn"
                      onClick={() => this.setFilter(3)}
                    >
                      Inquiry emails
                    </button>
                    <button
                    className="btn btn-light same-size-btn"
                    onClick={() => this.setFilter(null)}
                  >
                    Show All
                  </button>
                    </span>
                     )}
                    </Col>
                </Row>
                  
                
                {/* <div className="email-leftbar card">
                
                </div> */}
                <div className="email-rightbar mb-3" style={{marginLeft:0}}>
                  <Card>
                    {/* Render Email Top Tool Bar */}
                    <div className="btn-toolbar p-3" role="toolbar">
                    <div className="btn-group me-2 mb-2 mb-sm-0">
                    
                              {selectedEmails.length > 0 && (
                        <Button type="button" color="primary" onClick={this.handleDelete}>
                          <i className="far fa-trash-alt" />
                        </Button>
                      )}
                    </div>
                  
                  </div>
                    <TabContent
                      activeTab={this.state.activeTab}
                    >
                      <TabPane tabId="1">
                      <ul className="message-list">
                          {inboxMails?.filter((inbox) =>
                              this.state.filter
                                ? Number(inbox.customEmailTemplateId) === this.state.filter
                                : true
                            )
                            .map((inbox, key) => {
                            const createdOnDate = moment(inbox.createdOn);
                            const isToday = createdOnDate.isSame(moment(), 'day');
                            
                            return (
                              <li key={key}
                                style={
                                  Number(inbox.customEmailTemplateId) > 0 
                                    ? { backgroundColor: "white", color: "black" }
                                    : { backgroundColor: "white", color: "black" }   

                                }>
                                <div className="col-mail col-mail-1">
                                  <div className="checkbox-wrapper-mail">
                                    <Input type="checkbox" id={inbox.messageID}
                                      onChange={() => this.handleCheckboxChange(inbox.messageID)}
                                      checked={selectedEmails.includes(inbox.messageID)}
                                    />

                                    <Label htmlFor={inbox.messageID} className="toggle" />
                                  </div>
                                  <Link to={`/email-read/${inbox.emailDetailId}`} className={`title ${inbox.customEmailTemplateId == 0 ? 'has-no-template' : ''}`}>
                                    {inbox.from}
                                  </Link>
                                  {!isResponsive &&(
                                    <>
                                     {Number(inbox.customEmailTemplateId) == 1  && (
                                    <Link className="btn btn-light btn-buyer ms-auto" to={`/email-assign/${inbox.emailDetailId}`}>
                                      Buyer listings
                                    </Link>
                                  )}

                                   {Number(inbox.customEmailTemplateId) == 2  && (
                                    <Link className="btn btn-light btn-seller ms-auto" to={`/email-seller/${inbox.emailDetailId}`}>
                                      Seller listings
                                    </Link>
                                  )}

                                    {Number(inbox.customEmailTemplateId) == 3  && (
                                    <Link className="btn btn-light btn-inquiry ms-auto" to={`/email-inquery/${inbox.emailDetailId}`}>
                                      Inquiry emails
                                    </Link>
                                  )}
                                    </>
                                  )}
                                 
                                </div>
                                <div className={`col-mail col-mail-2 ${inbox.customEmailTemplateId == 0 ? 'has-no-mail' : ''}`}>
                                   {!isResponsive &&(
                                   <SafeHTML html={inbox.subject} />
                                  // <div dangerouslySetInnerHTML={{ __html: inbox.subject }}></div>
                                   )}
                                  <div className="date">
                                    {isToday
                                      ? createdOnDate.format('MMM DD, h:mm A')
                                      : createdOnDate.format('MMM DD, h:mm A')}

                                  </div>
                                </div>
                              </li>
                            );
                          })}
                        </ul>
                      </TabPane>
                    </TabContent>
                  </Card>
                  {/* Pagination Section */}
           <Row className="align-items-center">
  <Col xs="7">
    {/* Showing page info */}
    Showing {inboxMails?.length > 0
      ? `${(currentPage - 1) * 20 + 1} - ${Math.min(currentPage * 20, this.state.totalEmails)} of ${this.state.totalEmails}`
      : "No emails"}
  </Col>

  <Col xs="5">
    <div className="btn-group float-end">
      {/* Previous Button */}
      <Button
        type="button"
        color="success"
        size="sm"
        onClick={this.handlePreviousPage}
        disabled={currentPage === 1}
      >
        <i className="fa fa-chevron-left" />
      </Button>

      {/* Number Pagination with Ellipsis */}
      {this.getPaginationPages(currentPage, totalPages).map((page, index) =>
        page === '...' ? (
          <Button key={`ellipsis-${index}`} color="light" size="sm" disabled>
            ...
          </Button>
        ) : (
          <Button
            key={`page-${page}`}
            color={currentPage === page ? "primary" : "light"}
            size="sm"
            onClick={() => this.handlePageChange(page)}
          >
            {page}
          </Button>
        )
      )}

      {/* Next Button */}
      <Button
        type="button"
        color="success"
        size="sm"
        onClick={this.handleNextPage}
        disabled={currentPage === totalPages}
      >
        <i className="fa fa-chevron-right" />
      </Button>
    </div>
  </Col>
</Row>



              
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <Offcanvas
          isOpen={this.state.isMapper}
          direction="end"
          toggle={this.toggleEmailMapper}
          style={{width:800}}
        >
          <OffcanvasHeader toggle={this.toggleEmailMapper}>
           Email Mapper
          </OffcanvasHeader>
          <OffcanvasBody>
              <Formik
                              enableReinitialize={true}
                              initialValues={{
                                mappingFromEmail: "",
                                mappingTemplate: "",
                                parserTypeId: ''

                              }}
                              validationSchema={Yup.object().shape({
                                mappingFromEmail: Yup.string().email('Invalid email').required('This Field in required'),
                                //mappingToEmail: Yup.string().email('Invalid email').required('This Field in required'),
                                mappingTemplate: Yup.string().required("This Field in required"),
                                parserTypeId: Yup.string().required("This Field in required"),
                              })}
            
                              onSubmit={this.handleSubmitMapper}
                            >
                              {({ errors, touched, values, handleChange, setFieldValue }) => (
                                <Form
                                  className="needs-validation"
                                >
                               
                                     
                                      <Row>
                                        <Col sm="4">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="mappingFromEmail">
                                              From Email *
                                            </Label>
                                            <SafeField
                                              name="mappingFromEmail"
                                              onChange={handleChange}
            
                                              type="text"
            
                                              className={
                                                "form-control" +
                                                (errors.mappingFromEmail && touched.mappingFromEmail
                                                  ? " is-invalid"
                                                  : "")
                                              }
            
                                              id="mappingFromEmail"
                                            />
                                            <ErrorMessage
                                              name="mappingFromEmail"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
            
                                        {/* <Col sm="3">
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="mappingToEmail">
                                              To Email
                                            </Label>
                                            <SafeField
                                              name="mappingToEmail"
                                              onChange={handleChange}
            
                                              type="text"
            
                                              className={
                                                "form-control" +
                                                (errors.mappingToEmail && touched.mappingToEmail
                                                  ? " is-invalid"
                                                  : "")
                                              }
            
                                              id="mappingToEmail"
                                            />
                                            <ErrorMessage
                                              name="mappingToEmail"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col> */}
                                        <Col md="3">
            
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="mappingTemplate">
                                              Type *
                                            </Label>
                                            <SafeField as="select" name="mappingTemplate"
                                              className={
                                                "form-control" +
                                                (errors.mappingTemplate && touched.mappingTemplate
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                             onChange={(e) => {
                                                handleChange(e);
                                                this.loadParserType(e.target.value, setFieldValue);
                                              }}
                                              >
                                              <option value="">Select Type</option>
                                              <option value="1">Buyer Listings</option>
                                              <option value="2">Seller Showings</option>
                                              <option value="3">Lead Inquiries</option>
                                            </SafeField>
            
                                            <ErrorMessage
                                              name="mappingTemplate"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                           <Col md="3">
            
                                          <FormGroup className="mb-3">
                                            <Label htmlFor="parserTypeId">
                                              Select reader *
                                            </Label>
                                            <SafeField as="select" name="parserTypeId"
                                              className={
                                                "form-control" +
                                                (errors.parserTypeId && touched.parserTypeId
                                                  ? " is-invalid"
                                                  : "")
                                              }
                                              onChange={handleChange}>
                                              
                                              <option value="">Select Type</option>
                                              {parserTypes.map((item, index) => (
                                                <option key={index} value={item.id}>{item.parserTypeTitle}</option>
                                              ))}
                                            </SafeField>
            
                                            <ErrorMessage
                                              name="parserTypeId"
                                              component="div"
                                              className="invalid-feedback"
                                            />
                                          </FormGroup>
                                        </Col>
                                        <Col sm="2">
                                          <UpdateButton btnClass="mt-27">Add</UpdateButton>
            
                                        </Col>
            
            
                                      </Row>
            
            
            
            
                                   
            
                                 
                                      <h5 className="card-title">Email Mapper List</h5>
                                      <div className="">
                                        <table className="table table-bordered border-primary align-middle table-nowrap mb-0">
                                          <thead className="">
                                            <tr>
                                              <th>#</th>
            
                                              <th>From</th>
            
                                              {/* <th>To</th> */}
                                              <th>Template</th>

                                               <th>Reader</th>
            
                                              <th>Action</th>
            
            
                                            </tr>
                                          </thead>
                                          <tbody>
                                            {map(emailMapperList, (emailM, classkey) => (
                                              <tr key={"_list_" + classkey}>
                                                <th>{classkey + 1}</th>
                                                <td>{emailM.from}</td>
                                                {/* <td>{emailM.to}</td> */}
                                                <td>
                                                  <span>
                                                    {emailM.templateId === 1
                                                      ? "Buyer Listings"
                                                      : emailM.templateId === 2
                                                      ? "Seller Showings"
                                                      : emailM.templateId === 3
                                                      ? "Lead Inquiries"
                                                      : ""}
                                                  </span>
                                                </td>
                                                 <td>{localization["EmailParserType_" + emailM.parserTypeId]}
                                                      

                                                 </td>
                                                <td>
                                                  <a
                                                    href="#"
                                                    onClick={(e) => {
                                                      e.preventDefault();
                                                      this.handleTempDelete(emailM);
                                                    }}
                                                    className="action-button"
                                                  >
                                                    Delete
                                                  </a>
                                                </td>
                                              </tr>
                                            ))}
                                          </tbody>
                                        </table>
                                      </div>
                                 
                                </Form>
                              )}
                            </Formik>

          </OffcanvasBody>
          </Offcanvas>
        
         
      </React.Fragment>
    )
  }
}

EmailInbox.propTypes = {
  activeTab: PropTypes.string,
  isResponsive:PropTypes.object
}

const mapStateToProps = ({ Mails }) => ({

})

const mapDispatchToProps = dispatch => ({

})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(EmailInbox))